<template>
  <section class="add-a-critter">
    <h2>Help expand the site</h2>
    <p>We're always looking for more Creators to add to CR Market. If there is someone who  isn't on this site that you feel should be on here then please send us their Twitter handle or Website.</p>

    <form name="contact" method="POST" netlify>
      <input type='hidden' name='form-name' value='contact' />
      <ul class="form-fields">
        <li>
          <label for="email">Email:</label>
          <input name="email" type="email" id="email" required="">
        </li>
        <li>
          <label for="message">Message:</label>
          <textarea name="message" id="message" required=""></textarea>
        </li>
        <li>
          <div class="form-fields__controls">
            <button type="submit" class="button--submit">Send</button>
          </div>
        </li>
      </ul>
    </form>
  </section>
</template>

<script>
export default {
  name: 'ContactUs'
}
</script>


// WEBPACK FOOTER //
// ContactUs.vue?1538244c